<template>
  <div class="container-fluid mt-3">
    <div class="row justify-content-center">
      <manifest-cart-full-view></manifest-cart-full-view>
    </div>
  </div>
</template>
<script>
import ManifestCartFullView from '#/ui/Components/Manifest/ManifestCartFullView.vue';

export default {
  components: {
    ManifestCartFullView,
  },
  methods: {

  },
};
</script>
<style>

</style>
